import Splide from '@splidejs/splide';
import JsTabs from 'js-tabs';
import Detail from '@assets/product/detail';
import computedStyle from '../../utils/computedStyle';
import math from '../../utils/math';
import calculate from '../../utils/calculate';
import progress from '../../components/progress';
import listener from '../../utils/listener';
import image from '../../utils/image';
import multipack from '../../utils/multipack';
import update from '../../utils/update';
import { arrowPath } from '../../components/carousel';
import Zoom from '../../components/zoom';
import { loadRecommendationsCarousel } from '../../einsteinCarousel';

import QuickView from '../product/quickView';

document.addEventListener('DOMContentLoaded', (e) => {
  new QuickView().init();
});

// Module-level state. init() is re-executed on each QuickView opening
// (see quickView.js → quickview:ready), so delegated handlers on
// document/body/window should be attached ONLY ONCE. currentInstance always points
// to the last initialized instance: handlers access it to
// call methods/read instance selectors.
let globalHandlersBound = false;
let currentInstance = null;

function isQuickViewShown() {
  return $('#quickViewModal').length > 0 && $('#quickViewModal').hasClass('show');
}

function getActiveProductContainer() {
  return isQuickViewShown() ? $('#quickViewModal .product-quickview') : $('.product-detail');
}

function handleMultiPackClickSetItem($this, $setItemContainer) {
  const targetQuantity = $this.attr('data-quantity');
  const $setItemMultiPackItems = $setItemContainer.find('.multi-pack-items');
  const $setItemInput = $setItemContainer.find('.input-quantity').first();
  const $setItemSelect = $setItemContainer.find('.quantity-select').first();

  $this.addClass('is-active');
  $setItemMultiPackItems.not($this).removeClass('is-active');

  if ($setItemSelect.length) {
    $setItemSelect.find(`option[value="${targetQuantity}"]`).prop('selected', true);
    // Trigger change event to fetch stock info from server (via availability() listener in base.js)
    $setItemSelect.trigger('change');
  }

  if ($setItemInput.length) {
    $setItemInput.attr('value', targetQuantity).val(targetQuantity);
    math.update($setItemInput);
  }

  let $unitPriceContainer = $setItemContainer.find('.has-multipack-price').first();
  if (!$unitPriceContainer.length) {
    const $fallbackPrices = $setItemContainer.find('.details-container .prices').first();
    if ($fallbackPrices.length) {
      $fallbackPrices.addClass('has-multipack-price');
      $unitPriceContainer = $fallbackPrices;
    }
  }

  const $unitPriceValue = $unitPriceContainer.find('.sales .value').first().length
    ? $unitPriceContainer.find('.sales .value').first()
    : $unitPriceContainer.find('.value').first();
  const unitPrice = $this.attr('data-unitprice');
  const unitContent = $this.attr('data-unit-content');

  if ($unitPriceContainer.length && $unitPriceValue.length && unitPrice) {
    $unitPriceValue.text(unitPrice);
    if (unitContent !== undefined) {
      $unitPriceValue.attr('content', unitContent);
    }
    $unitPriceContainer.removeClass('d-none');
  }

  if ($setItemInput.length) {
    $setItemInput.trigger('after:quantitychange', $setItemInput);
  }
}

function handleMultiPackClickPdp($this) {
  const $productContainer = $this.closest('.product-detail');
  $productContainer.attr('data-user-multipack-click', 'true');

  const $items = $('.multi-pack-items');
  $this.addClass('is-active');
  $items.not($this).removeClass('is-active');

  if (isQuickViewShown()) {
    $('#quickViewModal input.qv-input-quantity').val($this.attr('data-quantity'));
  }
  const $pdpInput = $productContainer.find('.input-quantity').first();
  calculate.quantityMultiPack($pdpInput, $this.attr('data-quantity'), $pdpInput);
  math.update($pdpInput);

  const subscriptionUnitPrice = $this.data('unitprice-subscription');
  const multipackPrice = $this.data('unitprice');
  const subscriptionSave = $this.data('subscription-save');

  const subscriptionPriceContainer = $('.sor-price-container');
  if (subscriptionUnitPrice && subscriptionPriceContainer.length > 0) {
    if (subscriptionUnitPrice !== multipackPrice) {
      subscriptionPriceContainer.removeClass('d-none');
      subscriptionPriceContainer.find('.sor-price-container-value').html(subscriptionUnitPrice);
      if (subscriptionSave) {
        subscriptionPriceContainer.find('.smart-order-refill__saving-value').html(subscriptionSave);
        subscriptionPriceContainer.find('.smart-order-refill__saving-wrap:not(.no-saving)').removeClass('d-none');
      } else {
        subscriptionPriceContainer.find('.smart-order-refill__saving-wrap').addClass('d-none');
      }
    } else {
      subscriptionPriceContainer.addClass('d-none');
    }
  }
}

function handleMultiPackClick(e) {
  e.stopPropagation();
  const $this = $(e.currentTarget);
  const $setItemContainer = $this.closest('.product-detail.set-item');

  if ($setItemContainer.length > 0) {
    handleMultiPackClickSetItem($this, $setItemContainer);
    return;
  }
  handleMultiPackClickPdp($this);
}

function handleVariantChange(e, response) {
  const $eventContainer = response && response.container ? response.container : null;
  if ($eventContainer && $eventContainer.closest('.product-detail.set-item').length) {
    return;
  }
  if (!response || response.error || !currentInstance) return;

  const productContainer = getActiveProductContainer();
  const productData = response.data.product;

  if (!isQuickViewShown()) {
    image.carouselImageSingle(currentInstance.$sliderSingle);
    image.carousel(productData.images, productData.providerVideoUrl, productContainer);
    image.updateVideoCarousel(productData.privateLabelVideoUrls);
  }
  currentInstance.getWatermark(productData);
  currentInstance.getTopWatermark(productData);
  currentInstance.getPricePerKilo(productData, productData.idt_nascondi_prezzo_unitario);
  update.productDetails(productData, productContainer);
  currentInstance.handlerCarouselMultiPack(true, productData);
  currentInstance.syncMultiPackSuggestedSelection(productData, productContainer);
  currentInstance.handleRecommendedProductSet(productData.recommendedProductSet);
  update.productPriceWithMultiPack(productData);
  currentInstance.updateIncludedQuantityPrices(productData, productContainer);
}

function bindGlobalHandlersOnce() {
  if (globalHandlersBound) return;
  globalHandlersBound = true;

  // Accordion expand/collapse
  $(document).on('click', '.accordion-handler', (e) => {
    const $this = $(e.currentTarget);
    $this.toggleClass('open').next('.accordion-content').stop().slideToggle(300);
  });

  // Update price after variant change (with multipack)
  $('body').on('product:afterAttributeSelect', (e, response) => {
    const $eventContainer = response && response.container ? response.container : null;
    if ($eventContainer && $eventContainer.closest('.product-detail.set-item').length) return;
    if (!response || !response.data || !response.data.product) return;
    update.productPriceWithMultiPack(response.data.product, $eventContainer);
  });

  // Click on multipack option (PDP or set-item)
  $(document).on('click', '.product-detail .multi-pack-items, .product-detail.set-item .multi-pack-items', handleMultiPackClick);

  // Click on "default" attribute (non-color variations)
  $(document).on('click', '.default-attribute', (e) => {
    e.stopPropagation();
    const $this = $(e.currentTarget);
    const valueVariant = $this.data('attr-value');
    const $thisSelect = $this.parents('#attribute').find('.custom-select');
    const $attributeDefaultRow = $this.parents('#attribute').find('.default-attribute');

    if (!$this.hasClass('selected')) {
      $this.addClass('selected');
      $attributeDefaultRow.not($this).removeClass('selected');
      $thisSelect.find(`option[data-attr-value="${valueVariant}"]`).prop('selected', true).trigger('change');
    }
  });

  // Click on "color" attribute (placeholder no-op preserved)
  $(document).on('click', '.color-attribute', () => {});

  // Update product details after variant change
  $('body').on('product:afterAttributeSelect', handleVariantChange);

  // Progress bar after add-to-cart
  $('body').on('product:afterAddToCart', (e, response) => {
    if (!response || response.error) return;
    const valueShipping = $('.free-shipping-container').find('.value-shipping').data('value');
    const progressCart = parseFloat(response.cart.totals.subTotal.value);
    const progressTotal = calculate.progress(progressCart, valueShipping);
    const progressFreeShipping = valueShipping - progressCart;
    progress.build(progressTotal, progressFreeShipping);
  });

  // Sticky add-to-cart and scroll to footer-item--top
  $(document).on('click', '.sticky-add-to-cart .add-to-cart', () => {
    $('.footer-item--top').trigger('click');
  });

  // Show/hide sticky add-to-cart based on scroll
  $(window).on('scroll', () => {
    const $stickyAdd = $('.sticky-add-to-cart');
    if (!$stickyAdd.length) return;
    const $addToCartBtn = $('.add-to-cart').hasClass('d-none') ? $('.notifyme-button-container') : $('.add-to-cart');
    const addToCartRect = $addToCartBtn[0] ? $addToCartBtn[0].getBoundingClientRect() : null;
    const headerHeight = $('.main-navigation').height();
    if (addToCartRect && addToCartRect.bottom <= headerHeight) {
      $stickyAdd.addClass('is-active');
    } else {
      $stickyAdd.removeClass('is-active');
    }
  });

  // Click on Feedaty rating and scroll to section
  $(document).on('click', '.product-detail .product-rating .ratings', (e) => {
    e.preventDefault();
    const $section = $('#feedaty-section');
    if (!$section.length) return;
    const offsetHeightMenu = $('header').height();
    $('html, body').animate({ scrollTop: $section.offset().top - offsetHeightMenu }, 300);
  });
}

function destroyPreviousSplide(el) {
  const previous = $(el).data('splideInstance');
  if (previous && typeof previous.destroy === 'function') {
    previous.destroy(true);
  }
}

export default class extends Detail {
  constructor() {
    super();
    const inQuickView = isQuickViewShown();
    const $root = inQuickView ? $('#quickViewModal') : $(document);
    // Dynamics Selectors
    this.$slider = inQuickView ? '#quickViewModal #slider' : '#slider';
    this.$sliderSingle = inQuickView ? '#quickViewModal #slider-single' : '#slider-single';
    this.$thumbnail = inQuickView ? '#quickViewModal #thumbnail' : '#thumbnail';
    this.$sliderProductSet = inQuickView ? '#quickViewModal .set-item .primary-slider' : '.set-item .primary-slider';
    this.$thumbnailProductSet = inQuickView ? '#quickViewModal .set-item .secondary-slider' : '.set-item .secondary-slider';
    this.$multiPack = inQuickView ? '#quickViewModal .multi-pack-slider' : '.multi-pack-slider';
    this.$multiPackContainer = $root.find('.multi-pack');
    this.$recommendedProductSetContainer = $root.find('.js-recommended-product-set-container');
    this.$myJsTabsRelated = inQuickView ? '#quickViewModal #related' : '#related';
    this.$myJsTabsDetail = inQuickView ? '#quickViewModal #detail' : '#detail';
    // Common Selectors ($root)
    this.$addToCart = $root.find('.add-to-cart');
    this.$shippingContainer = $root.find('.free-shipping-container');
    this.valueShipping = this.$shippingContainer.find('.value-shipping').data('value');
    this.$miniCart = $('.minicart .minicart-subtotal');
    this.$ratings = $root.find('.product-rating .ratings');
    this.$feedaty = $root.find('#feedaty-carousel');
    this.$inputQuantity = $root.find('.input-quantity');
    this.$quantityWrap = $root.find('.quantity-change');
    this.$attributeWrap = $root.find('.attributes-items');
    this.$attributeDefault = this.$attributeWrap.find('.default-attribute');
    this.$attributeColor = this.$attributeWrap.find('.color-attribute');
    this.$inputCounter = this.$quantityWrap.find('.input-quantity');
    this.$productContainer = $root.find('.product-detail');
    this.$detailContainer = $root.find('.details-container');
    this.locale = this.$productContainer.data('locale');
    this.currency = this.$productContainer.data('currency');
    this.$multiPackSelector = $root.find('.multi-pack');
    this.$multiPackItems = $root.find('.multi-pack-items');
    this.breakpoints = parseInt(computedStyle.get('--breakpoint-xl'));
  }

  // Getter DOM-based: la verità è sempre nello stato attuale del modal,
  // così gli handler globali e i metodi d'istanza leggono sempre il valore
  // corretto anche dopo aperture/chiusure successive del QuickView.
  get isQuickViewShown() {
    return isQuickViewShown();
  }

  init() {
    super.init();
    currentInstance = this;
    bindGlobalHandlersOnce();

    this.handlerTableDecorator();
    this.handlerTabsRelated();
    this.handlerTabsDetail();
    this.handlerMultiPackPrice();
    this.handlerCarouselMultiPack();
    this.handlerCarouselServiceCategory();
    this.handlerCarouselBrand();
    this.handlerCarouselVariantion();
    this.observerFeedaty();
    this.handlerDataLayer();

    if (!this.isQuickViewShown) {
      const $productSetSliders = $(this.$sliderProductSet);
      const $productSetThumbnails = $(this.$thumbnailProductSet);

      if ($productSetSliders.length > 0 && $productSetThumbnails.length > 0) {
        $productSetSliders.each((index, sliderElement) => {
          const thumbnailElement = $productSetThumbnails.get(index);
          if (thumbnailElement) {
            image.carouselImage(sliderElement, thumbnailElement);
          }
        });
      } else {
        image.carouselImage(this.$slider, this.$thumbnail);
      }

      image.zoom(this.$slider);
      if ($(this.$sliderSingle).length > 0) {
        image.zoom(this.$sliderSingle);
        image.carouselImageSingle(this.$sliderSingle);
      }
      image.setVideoModal();
      image.setThumbVideoCover();
      image.initVideoCarousel();
    }
    this.handlerPanningZoom();
    this.notifyMeQuantityHandler();

    if (this.$multiPackSelector.length > 0) {
      listener.multiPack(this.$multiPackItems, 'change', '.input-quantity');
    }

    if (this.$shippingContainer.length > 0) {
      if (!this.$miniCart.attr('value')) return;
      const regex = /[€\s,]/g;
      const callback = function (match) {
        if (match === ',') return '.';
        return '';
      };
      const formatValueSubTotal = parseFloat(this.$miniCart.attr('value').replace(regex, callback));
      const subTotals = calculate.progress(formatValueSubTotal, this.valueShipping);
      const progressFreeShipping = this.valueShipping - formatValueSubTotal;
      const productContainer = this.isQuickViewShown ? $('#quickViewModal .product-quickview') : $('.product-detail');
      progress.build(subTotals, progressFreeShipping, productContainer);
    }

    update.setSorCostPerPrice();
    loadRecommendationsCarousel();
  }

  handlerCarouselMultiPack(fromHandleVariant = false, response) {
    const getMultipackSliders = () => (this.isQuickViewShown ? $('#quickViewModal .multi-pack-slider') : $('.multi-pack-slider'));

    if (fromHandleVariant) {
      const productContainer = this.isQuickViewShown ? $('#quickViewModal .product-quickview') : $('.product-detail');
      const isMultipackClick = productContainer.attr('data-user-multipack-click') === 'true';

      // Click on a multipack option: same variation, same options → the is-active
      // Avoid destroy+remount of the Splide.
      if (isMultipackClick) return;

      this.$multiPackContainer.removeClass('multi-pack mb-3').addClass('multipack-container').html(response.multiPackHtml);
      if (response.multiPack.length > 0) {
        multipack.mountSliders(getMultipackSliders());
      }
    } else if (this.$multiPackContainer.length > 0) {
      multipack.mountSliders(getMultipackSliders());
    }
  }

  handlerMultiPackPrice() {
    const productContainer = this.isQuickViewShown ? $('#quickViewModal .product-quickview') : $('.product-detail');

    if (!this.isQuickViewShown && $('.product-detail.set-item').length > 0) {
      $('.product-detail.set-item').each((index, item) => {
        const $row = $(item);
        const currentQty = $row.find('.input-quantity').val();
        const $multiPackItems = $row.find('.multi-pack-items');
        let hasCompatibleMatch = false;

        // Match quantity to nearest multipack option <= current quantity.
        if (currentQty && $multiPackItems.length) {
          const currentQtyNum = parseInt(currentQty, 10);
          let bestQty = -1;
          let $matchingMultiPack = $();

          $multiPackItems.each((idx, el) => {
            const optionQty = parseInt($(el).attr('data-quantity'), 10);
            if (!isNaN(optionQty) && !isNaN(currentQtyNum) && optionQty <= currentQtyNum && optionQty > bestQty) {
              bestQty = optionQty;
              $matchingMultiPack = $(el);
            }
          });

          if ($matchingMultiPack.length) {
            $multiPackItems.removeClass('is-active');
            $matchingMultiPack.addClass('is-active');
            hasCompatibleMatch = true;
          }
        }

        // Update price only if there's a compatible multipack match.
        if (!hasCompatibleMatch) {
          // No match - deactivate all multipack items and reset price to default.
          $multiPackItems.removeClass('is-active');
          return;
        }

        const $priceValue = $row.find('.has-multipack-price .value');
        const $activeOption = $row.find('.multi-pack-items.is-active').first();

        if (!$priceValue.length || !$activeOption.length) {
          return;
        }

        $priceValue.text($activeOption.attr('data-unitprice'));
        $priceValue.attr('content', $activeOption.attr('data-unit-content'));
        $row.find('.has-multipack-price').removeClass('d-none');
      });

      return;
    }

    // PDP page - match quantity to multipack if it exists - ONLY if exact match
    const currentQty = productContainer.find('.input-quantity').val();
    const $multiPackItems = productContainer.find('.multi-pack-items');
    let hasCompatibleMatch = false;

    if (currentQty && $multiPackItems.length) {
      const currentQtyNum = parseInt(currentQty, 10);
      let bestQty = -1;
      let $matchingMultiPack = $();

      $multiPackItems.each((idx, el) => {
        const optionQty = parseInt($(el).attr('data-quantity'), 10);
        if (!isNaN(optionQty) && !isNaN(currentQtyNum) && optionQty <= currentQtyNum && optionQty > bestQty) {
          bestQty = optionQty;
          $matchingMultiPack = $(el);
        }
      });

      if ($matchingMultiPack.length) {
        $multiPackItems.removeClass('is-active');
        $matchingMultiPack.addClass('is-active');
        hasCompatibleMatch = true;
      }
    }

    // Update price only if there's a compatible multipack match.
    if (productContainer.find('.details-top .has-multipack-price').length > 0) {
      if (hasCompatibleMatch) {
        const $activeOption = productContainer.find('.multi-pack-items.is-active');
        const price = $activeOption.attr('data-unitprice');
        const unit = $activeOption.attr('data-unit-content');
        productContainer.find('.has-multipack-price .value').text(price);
        productContainer.find('.has-multipack-price .value').attr('content', unit);
        productContainer.find('.has-multipack-price').removeClass('d-none');

        const subscriptionUnitPrice = $activeOption.data('unitprice-subscription');
        const subscriptionSave = $activeOption.data('subscription-save');
        const $subscriptionPriceContainer = productContainer.find('.sor-price-container');
        if (subscriptionUnitPrice && $subscriptionPriceContainer.length > 0) {
          if (subscriptionUnitPrice !== price) {
            $subscriptionPriceContainer.removeClass('d-none');
            $subscriptionPriceContainer.find('.sor-price-container-value').html(subscriptionUnitPrice);
            if (subscriptionSave) {
              $subscriptionPriceContainer.find('.smart-order-refill__saving-value').html(subscriptionSave);
              $subscriptionPriceContainer.find('.smart-order-refill__saving-wrap:not(.no-saving)').removeClass('d-none');
            } else {
              $subscriptionPriceContainer.find('.smart-order-refill__saving-wrap').addClass('d-none');
            }
          } else {
            $subscriptionPriceContainer.addClass('d-none');
          }
        }
      } else {
        // No match - deactivate all multipack items and reset price to default
        $multiPackItems.removeClass('is-active');
        productContainer.find('.has-multipack-price').addClass('d-none');
      }
    }
  }

  handleRecommendedProductSet(productSet) {
    if (!productSet || (productSet.products && productSet.products.length < 2)) {
      this.$recommendedProductSetContainer.addClass('d-none');
    } else {
      this.$recommendedProductSetContainer.removeClass('d-none');
      this.$recommendedProductSetContainer.empty().html(productSet.renderedProductSet);
    }
  }

  handlerTableDecorator() {
    $('.description-and-detail')
      .find('table')
      .each((index, elem) => {
        $(elem).removeAttr('style').addClass('table table-bordered table-striped');
        $(elem).find('tr').removeAttr('style');
        $(elem).find('td').removeAttr('style');
        if (!$(elem).closest().hasClass('table-responsive')) {
          $(elem).wrap('<div class="table-responsive" />');
        }
      });
  }

  handlerTabsRelated() {
    const $elm = $(this.$myJsTabsRelated);
    if (!$elm.length || $elm.data('jsTabsInitialized')) return;
    const myTabs = new JsTabs({
      elm: this.$myJsTabsRelated,
      shouldScrollTabIntoView: false
    });
    myTabs.init();
    $elm.data('jsTabsInitialized', true);
  }

  handlerTabsDetail() {
    const $elm = $(this.$myJsTabsDetail);
    if (!$elm.length || $elm.data('jsTabsInitialized')) return;
    const myTabs = new JsTabs({
      elm: this.$myJsTabsDetail,
      shouldScrollTabIntoView: false
    });
    myTabs.init();
    $elm.data('jsTabsInitialized', true);
  }

  handlerCarouselServiceCategory() {
    const service = document.getElementById('service');
    if (!service) return;
    destroyPreviousSplide(service);
    const instance = new Splide(service, {
      perPage: 4,
      gap: 20,
      pagination: false,
      arrows: false,
      breakpoints: {
        640: {
          perPage: 1,
          pagination: true
        },
        1024: {
          perPage: 2
        }
      }
    });
    instance.mount();
    $(service).data('splideInstance', instance);
  }

  handlerCarouselBrand() {
    if (this.isQuickViewShown) return false;
    try {
      const $brand = $('.brand');
      if ($brand.length) {
        $brand.each((index, el) => {
          destroyPreviousSplide(el);
          const instance = new Splide(el, {
            perPage: 5,
            perMove: 5,
            gap: 20,
            pagination: false,
            arrows: false,
            breakpoints: {
              640: {
                perPage: 1,
                pagination: true
              },
              1024: {
                perPage: 2
              }
            }
          });
          instance.mount();
          $(el).data('splideInstance', instance);
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  handlerCarouselVariantion() {
    const resource = require('../../utils/resource').default;
    const configs = {
      perMove: 3,
      perPage: 3,
      pagination: false,
      arrows: true,
      i18n: {
        prev: resource.msg('button.previous', 'common'),
        next: resource.msg('button.next', 'common')
      },
      isNavigation: true,
      gap: 11,
      arrowPath: arrowPath
    };

    try {
      const $attribute = $('.attribute-list').filter((index, item) => $(item).closest('.multi-pack').length === 0);
      if ($attribute.length) {
        $attribute.each((index, el) => {
          destroyPreviousSplide(el);
          const instance = new Splide(el, configs);
          instance.mount();
          $(el).data('splideInstance', instance);
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  syncMultiPackSuggestedSelection(productData, productContainer) {
    if (!productData || !productContainer) return;

    // Verifica se l'utente ha cliccato manualmente su un'opzione multipack
    const userClicked = productContainer.attr('data-user-multipack-click') === 'true';
    if (userClicked) {
      // Rimuove il flag per consentire future sincronizzazioni
      productContainer.removeAttr('data-user-multipack-click');
      return;
    }

    const currentQty = productContainer.find('.input-quantity').first().val() || productContainer.find('.quantity-select').first().val();
    const currentQtyNum = parseInt(currentQty, 10);
    const $multiPackItems = productContainer.find('.multi-pack-items');
    if (!$multiPackItems.length) return;

    $multiPackItems.removeClass('is-active');

    let bestQty = -1;
    let $bestMatch = $();
    $multiPackItems.each((index, element) => {
      const optionQty = parseInt($(element).attr('data-quantity'), 10);
      if (!isNaN(optionQty) && !isNaN(currentQtyNum) && optionQty <= currentQtyNum && optionQty > bestQty) {
        bestQty = optionQty;
        $bestMatch = $(element);
      }
    });

    if ($bestMatch.length) {
      $bestMatch.addClass('is-active');
    }
  }

  updateIncludedQuantityPrices(productData, productContainer) {
    const $includedQuantityProductPrice = productContainer.find('.included-qty-productPrice');
    const $includedQuantitySorPrice = productContainer.find('.included-qty-sorPrice');

    const productPrice =
      productData.includedQuantityPrice && productData.includedQuantityPrice.productPrice
        ? productData.includedQuantityPrice.productPrice
        : null;

    const sorPrice =
      productData.includedQuantityPrice && productData.includedQuantityPrice.sorPrice ? productData.includedQuantityPrice.sorPrice : null;

    const handleIncludeQuanityPrices = function (priceData, container) {
      if (container.length > 0 && priceData) {
        container.empty().html(priceData);
        container.show();
      } else {
        container.hide();
      }
    };

    handleIncludeQuanityPrices(productPrice, $includedQuantityProductPrice);
    handleIncludeQuanityPrices(sorPrice, $includedQuantitySorPrice);
  }

  observerFeedaty() {
    if (this._topRatingsObserver) {
      this._topRatingsObserver.disconnect();
      this._topRatingsObserver = null;
    }
    if (this._feedatyObserver) {
      this._feedatyObserver.disconnect();
      this._feedatyObserver = null;
    }

    if (this.$ratings.length > 0) {
      this._topRatingsObserver = new MutationObserver(() => {
        if (this.$ratings.find('[class*="fdt"]').length > 0) {
          this.$ratings.parent().removeClass('d-none');
        }
      });
      this._topRatingsObserver.observe(this.$ratings[0], {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    if (this.$feedaty.length > 0) {
      this._feedatyObserver = new MutationObserver(() => {
        if (this.$feedaty.find('[class*="fdt"]').length > 0) {
          this.$feedaty.parent().removeClass('d-none');
        }
      });
      this._feedatyObserver.observe(this.$feedaty[0], {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }

  handlerDataLayer() {
    if (this.isQuickViewShown) return;
    if (dataLayer) {
      const category = [];
      const $wrapper = $('.product-detail');

      $('.breadcrumb-item:not(:first)').each((index, elem) => {
        category.push($.trim($(elem).children().text()));
      });

      const dataLayerProduct = {
        name: $wrapper.attr('data-name'),
        id: $wrapper.attr('data-pid'),
        price: $wrapper.attr('data-price'),
        brand: $wrapper.attr('data-brand')
      };

      for (let i = 0; i < category.length; i++) {
        dataLayerProduct['item_category' + (i > 0 ? i + 1 : '')] = category[i];
      }

      dataLayer.push({
        event: 'productView',
        ecommerce: {
          detail: {
            products: [dataLayerProduct]
          }
        }
      });

      listener.dataLayerAddToCartHandler(category);
    }
  }

  handlerPanningZoom() {
    return new Zoom().init();
  }

  getWatermark(productData) {
    const watermarkType = productData.watermarks && productData.price.watermarkType ? productData.price.watermarkType : null;
    const watermarks = productData.watermarks;

    if (!productData.hasPromoCategory || !productData.activedOmnibusWatermarkPreference) {
      return image.watermark(productData['idt-watermark-image'], productData);
    } else {
      if (watermarkType) {
        if (watermarkType === 'giu prezzo') {
          return image.watermark(watermarks.giu_i_prezzi, productData, watermarkType);
        } else if (watermarkType === 'prezzo protetto') {
          return image.watermark(watermarks.prezzo_protetto, productData, watermarkType);
        }
      } else {
        return image.watermark(productData['idt-watermark-image'], productData);
      }
    }
  }

  getTopWatermark(productData) {
    const topWatermark = productData['idt-top-watermark'] ? productData['idt-top-watermark'] : false;

    if (topWatermark) {
      return image.watermark(topWatermark, productData);
    }
  }

  getPricePerKilo(productData, hidePricePerKilo) {
    // eslint-disable-next-line no-useless-return
    if (!productData || !productData['idt-qfis'] || !productData['idt-cumd']) return;

    const productContainer = getActiveProductContainer();
    const idtQfis = productData['idt-qfis'];
    const idtCumd = productData['idt-cumd'];
    const kgValue = productData.price.sales.value / idtQfis;
    const formattedKgValue = kgValue
      .toLocaleString('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
      .replace(/\s+/g, '');
    const kgPrice = `(${formattedKgValue}/${idtCumd})`;
    const $productQfis = productContainer.find('.product-qfis').first();
    if (!$productQfis.length) {
      const priceContainer = productContainer.find('.details-top > .prices').first()[0];

      if (priceContainer) {
        priceContainer.insertAdjacentHTML(
          'beforeend',
          `<p class="product-qfis ml-2" data-idt-qfis="${idtQfis}" data-idt-cumd="${idtCumd}">${kgPrice}</p>`
        );
      }
    } else {
      $productQfis.html(kgPrice);
      $productQfis.attr('data-idt-qfis', idtQfis);
      $productQfis.attr('data-idt-cumd', idtCumd);
    }

    productContainer.find('.product-qfis').toggle(hidePricePerKilo !== true);
  }

  notifyMeQuantityHandler() {
    $('.notifyme-modal').on('show.bs.modal', () => {
      const quantityRequested = $('.details-container .input-quantity').val();
      if (quantityRequested) {
        $('#quantityRequested').val(quantityRequested);
      }
    });
  }
}
